import Vuex from "vuex";
import Vue from "vue";
import moment from "moment";
import initialFreeOrders from "./initialFreeOrders";
import initialSequencedOrders from "./initialSequencedOrders";
import createItems from "../components/Gantt/createItems";
import OrderModel from "../models/OrderModel";
import { findOrderIdx, getLastRow } from "./helpers";

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    rightSheet: {
      operacao: "",
      sequenciada: null,
    },
    ganttChart: {
      moment: moment(),
    },
    maquinas: [{}],
    orders: {
      free: initialFreeOrders,
      sequenced: createItems.createItems(initialSequencedOrders),
    },
  },
  mutations: {
    removeFreeOrder(state, codigo) {
      const index = state.orders.free.findIndex(
        (order) => order.codigo === codigo
      );
      const order = state.orders.free[index];
      order.setTime(
        moment()
          .startOf("day")
          .add(Math.floor(Math.random() * 3) + 1, "hours")
          .valueOf(),
        moment()
          .startOf("day")
          .add(Math.floor(Math.random() * 7) + 4, "hours")
          .valueOf()
      );

      order.setRow(getLastRow(state.orders.sequenced) + 1);
      order.setMoveable(true);
      const seqIdx = Object.keys(state.orders.sequenced).length + 1;
      this._vm.$set(
        state.orders.sequenced,
        seqIdx.toString(),
        createItems.createItem(order, seqIdx)
      );
      state.orders.free.splice(index, 1);
    },
    divideOrder(state, order) {
      //provavel solução manter valor end
      let { start, end } = order.time;
      start = moment(start);
      end = moment(end);
      const duration = moment.duration(end.diff(start)).asSeconds();

      const newHalfOrder = OrderModel.novaSequenciada(
        order.label,
        start.add(duration / 2, "seconds").valueOf(),
        end.valueOf()
      );
      //newHalfOrder.setNextLabel();

      order.time.end = end.add(-duration / 2, "seconds").valueOf();

      newHalfOrder.setRow(order.rowId);
      newHalfOrder.setBackground(order.style.background);
      const seqIdx = Object.keys(state.orders.sequenced).length + 1;
      this._vm.$set(
        state.orders.sequenced,
        seqIdx.toString(),
        createItems.createItem(newHalfOrder, seqIdx)
      );
      /**
       * Codigo alternativa para adição
       * state.orders.sequenced = {
        ...state.orders.sequenced,
        [seqIdx.toString()]: createItems.createItem(newHalfOrder, seqIdx),
      };
       */
    },
    joinOrders(state, order) {
      const orders = state.orders.sequenced;

      const orderArr = Object.values(orders).filter((ord) =>
        OrderModel.isSameOrder(order.label, ord.label)
      );
      if (orderArr.length === 1) {
        return; // Não há opções para juntar
      }
      orderArr.sort((order1, order2) => order1.time.start - order2.time.start);
      const orderIdx = orderArr.findIndex((ord) => ord.label === order.label);
      if (orderIdx === orderArr.length - 1) {
        const prevOrder = orderArr[orderIdx - 1];
        const prevOrderEnd = moment(prevOrder.time.end);
        const lastOrderStart = moment(order.time.start);
        const lastOrderEnd = moment(order.time.end);
        const lastOrderDuration = moment
          .duration(lastOrderEnd.diff(lastOrderStart))
          .asSeconds();
        const indexToDelete = findOrderIdx(orders, order);
        delete orders[indexToDelete];

        prevOrder.time.end = prevOrderEnd
          .add(lastOrderDuration, "seconds")
          .valueOf();
        return;
      }

      const nextOrder = orderArr[orderIdx + 1];

      const orderEnd = moment(order.time.end);
      const nextOrderStart = moment(nextOrder.time.start);
      const nextOrderEnd = moment(nextOrder.time.end);
      const nextOrderduration = moment
        .duration(nextOrderEnd.diff(nextOrderStart))
        .asSeconds();
      const indexToDelete = findOrderIdx(orders, nextOrder);
      delete orders[indexToDelete];
      order.time.end = orderEnd.add(nextOrderduration, "seconds").valueOf();
    },
    removeSequencedOrder(state, codigo) {
      let order = {};
      let idx = -1;
      for (let index in state.orders.sequenced) {
        order = state.orders.sequenced[index];
        if (order.label === codigo) {
          idx = index;
          break;
        }
      }
      state.orders.free.push(state.orders.sequenced[idx]);
      delete state.orders.sequenced[idx];
    },
    changeRightSheetOp(state, { operacao, sequenciada }) {
      state.rightSheet.operacao = operacao || operacao;
      state.rightSheet.sequenciada = sequenciada || null;
    },
    changeTime(state, newMoment) {
      state.ganttChart.moment = newMoment;
    },
    resetTime(state) {
      state.ganttChart.moment = moment();
    },
    advanceTime(state, { tipo, quantidade }) {
      /*
        tipo -> days, weeks, months, years / STRING
        quantidade -> Número de dias/meses para avançar, pode ser negatvo // Inteiro
      */
      state.ganttChart.moment = state.ganttChart.moment
        .clone()
        .add(quantidade, tipo);
    },
  },
  getters: {
    getOrder: (state) => (codigo) => {
      const orders = state.orders.sequenced;
      for (let idx in orders) {
        const order = orders[idx];
        if (order.label === codigo) {
          return order;
        }
      }
    },
  },
  actions: {},
});

export default store;
